import React from 'react';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { useNavigate } from 'react-router-dom';

import '../css/CategorySelectionPage.css';
import '../css/global.css';

function CategorySelectionPage() {
  const navigate = useNavigate();

  return (
    <div>
      <center><h1>Auswahl der einzelnen Module</h1></center>
      <div className="p-grid">
        <div className="p-col-12">
          <Card>
            <div className="category-container category-selection-container">
              <Button
                label="Praxismodul 1"
                className="category-button"
                onClick={() => navigate('/module/pm1')}
              />
              <Button
                label="Praxismodul 2"
                className="category-button"
                onClick={() => navigate('/module/pm2')}
              />
              <Button
                label="Gesundheit & Pflege"
                className="category-button"
                onClick={() => navigate('/module/gp')}
              />
              <Button
                label="Organisation & Planung"
                className="category-button"
                onClick={() => navigate('/module/op')}
              />
            </div>
          </Card>
        </div>
      </div>
    </div >
  );
}

export default CategorySelectionPage;